import { FiltersMap } from '@wix/bex-core';
import { InfiniteScrollTableState } from '../../state';
import { action, makeObservable } from 'mobx';
import { CollectionDragAndDropState } from './CollectionDragAndDropState';

export interface TableDragAndDropStateParams<T, F extends FiltersMap> {
  readonly tableState: InfiniteScrollTableState<T, F>;
  readonly modalsContainerRef: {
    current: HTMLElement | null | undefined;
  };
}

export class TableDragAndDropState<T, F extends FiltersMap> {
  readonly tableState;
  readonly dragAndDrop;

  constructor(params: TableDragAndDropStateParams<T, F>) {
    this.tableState = params.tableState;
    this.dragAndDrop = new CollectionDragAndDropState({
      state: params.tableState.toolbar,
      container: params.tableState.toolbar.container,
      a11yContainer: params.modalsContainerRef?.current,
    });

    makeObservable(this, {
      init: action,
    });
  }

  getStickyColumnsCount({
    stickyColumns,
    horizontalScroll,
  }: {
    stickyColumns: number;
    showSelection?: boolean;
    horizontalScroll?: boolean;
  }) {
    const { dragAndDrop } = this;
    return horizontalScroll && !dragAndDrop.dnd.isDisabled
      ? stickyColumns + 1
      : stickyColumns;
  }

  init({ a11yContainer }: { a11yContainer?: HTMLElement | null | undefined }) {
    const { dragAndDrop, tableState } = this;

    tableState.tableDragAndDropStateInitialized = true;

    return dragAndDrop.init({
      a11yContainer,
    });
  }
}
